export const setUsuarios = (state, usuarioslista) => {
  state.usuarioslista = usuarioslista.data;
}

export const setUsuariosInfo = (state, usuariosinfo) => {
  state.usuariosinfo = usuariosinfo.data;
}

